import Dialog from "@mui/material/Dialog";
import MuiDialogActions from "@mui/material/DialogActions";
import MuiDialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import MuiDialogTitle from "@mui/material/DialogTitle";
import { withStyles } from "@mui/styles";
import * as React from "react";

import "./ConfirmationModal.scss";

export interface IConfirmationModalProps {
  title: string;
  confirmText: string;
  open: boolean;
  onCancel?: () => void;
}

const DialogTitle = withStyles(theme => ({
  root: {
    "& h6": {
      fontSize: "2rem",
    },
  },
}))(MuiDialogTitle);

const DialogContent = withStyles(theme => ({
  root: {
    "& p": {
      fontSize: "1rem",
      lineHeight: "2",
      marginBottom: 0,
      color: theme.palette.text.primary,
    },
    "& div": {
      marginTop: "1rem",
    },
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    marginBottom: "1,5rem",
    padding: theme.spacing(1),
    display: "flex",
    flexDirection: "row",
  },
}))(MuiDialogActions);

class ConfirmationModal extends React.Component<IConfirmationModalProps> {
  constructor(props: IConfirmationModalProps) {
    super(props);
  }

  handleClickOpen = () => {};

  handleClose = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();

    const { onCancel } = this.props;
    this.setState({ open: false });

    if (onCancel) {
      onCancel();
    }
  };

  render() {
    const { children, title, confirmText, open } = this.props;
    return (
      <Dialog
        open={open}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            width: "64rem",
          },
        }}>
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">{children}</DialogContentText>
        </DialogContent>

        <DialogActions>
          <button className="button-v2  primary" onClick={this.handleClose} autoFocus>
            {confirmText}
          </button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ConfirmationModal;
